(function () {
  // escape hatch
  if (!document.body.classList.contains("single-event")) return;

  // setup
  let initialized = false;
  const database = firebase.database(),
    envKey = WP.envKey,
    pageID = WP.pageID;

  // autorun
  database
    .ref(`${envKey}/event${pageID}/refresh`)
    .on("value", function (snapshot) {
      if (initialized) {
        const type = snapshot.val().split("__")[0];
        if (type === "page") {
          database
            .ref(`${envKey}/event${pageID}/refreshDelayWindow`)
            .once("value", function (snapshot) {
              // random millisecond value between 0 and <configurable delay> seconds
              let delay = Math.floor(Math.random() * snapshot.val() * 1000);
              console.info(`Force refreshing in ${delay}s...`);
              let counter = 0;
              setInterval(() => {
                counter++;
                console.log(counter);
              }, 1000);
              setTimeout(() => location.reload(), delay);
            });
        }
      }
      // reset for next autorun
      initialized = true;
    });
})();
